import { render, staticRenderFns } from "./backgroundSupply.vue?vue&type=template&id=63fb431a&"
import script from "./backgroundSupply.vue?vue&type=script&lang=js&"
export * from "./backgroundSupply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports